import React from 'react';

import { Badge, HStack } from '@rtkwlf/fenrir-react';
import type { BadgeRootProps } from '@rtkwlf/fenrir-react';
import { useTranslation } from 'react-i18next';

type TicketStatusBadgeProps = {
  value: string;
};

type BadgeAppearance = BadgeRootProps['appearance'];

// TODO: Update to Fenrir v2
export const TicketStatusBadge: React.FC<TicketStatusBadgeProps> = (props) => {
  const { t } = useTranslation();
  const { value } = props;
  let statusText: string;

  if (typeof value !== 'string') return null;

  let appearance: BadgeAppearance = 'default';

  switch (value.toLowerCase()) {
    case 'new':
    case 'open':
    case 'hold':
      appearance = 'warning';
      statusText = t('ticket:ticketStatus:withAW');
      break;
    case 'pending':
      appearance = 'danger';
      statusText = t('ticket:ticketStatus:withCustomer');
      break;
    default:
      appearance = 'default';
      statusText = t('ticket:ticketStatus:closed');
  }

  return (
    <HStack alignItems="center">
      <Badge.Root appearance={appearance}>
        <Badge.Text textTransform="capitalize">{statusText}</Badge.Text>
      </Badge.Root>
    </HStack>
  );
};
